import { gql } from "@apollo/client";

export const GET_SELLER_UNITS_AND_PROJECTS_MAP = gql`
	query SellerUnitsAndProjects($params: SellerUnitsAndProjectsParams) {
		sellerUnitsAndProjects(params: $params) {
			map {
				_id
				localityName
				projectId
				projectName
				propertyTypes
				center {
					lat
					lng
				}
				zoom
				sups {
					_id
					appCoverImage
					amenities
					bathrooms
					bedrooms
					builtUpAreas
					cover
					facings
					mediaList {
						name
						space
						type
						url
					}
					parkings
					prices
					sellerProjectId
					totalUnits
					type
				}
			}
		}
	}
`;

export const GET_SELLER_UNITS_AND_PROJECTS_MAP_BASED_SEARCH = gql`
	query SellerUnitsAndProjectsMapBasedSearch($params: SellerUnitsAndProjectsParams) {
		sellerUnitsAndProjects(params: $params) {
			mapBasedSearch {
				data {
					_id
					localityName
					projectId
					projectName
					propertyTypes
					center {
						lat
						lng
					}
					zoom
					sups {
						_id
						appCoverImage
						amenities
						bathrooms
						bedrooms
						builtUpAreas
						cover
						facings
						mediaList {
							name
							space
							type
							url
						}
						parkings
						prices
						sellerProjectId
						totalUnits
						type
						updatedAt
					}
					isExactMatch
				}
				locations {
					id
					name
					coordinates
				}
			}
		}
	}
`;

export const GET_SELLER_UNITS_AND_PROJECTS_TOTAL_COUNT = gql`
	query SellerUnitsAndProjectsTotalCount($params: SellerUnitsAndProjectsParams) {
		sellerUnitsAndProjects(params: $params) {
			map {
				totalCount
			}
		}
	}
`;
